import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TextFieldGroupComponent } from './text-field-group.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    TextFieldGroupComponent
  ],
  exports: [
    TextFieldGroupComponent
  ]
})
export class TextFieldGroupModule {
}
